'use client';

import { useTranslations } from '@northladder/i18n';
import { ECourierStatus } from '@northladder/services';

interface IDealCourierStatusTranslations {
  label: string;
  description: string;
  title: string;
}

/**
 * This receives the `courierStatus` status and returns a well translated label.
 * If the status is not recognized, it defaults to `"Unknown"`.
 */
export function useDealCourierStatusTranslations(
  status: ECourierStatus
): IDealCourierStatusTranslations {
  const t = useTranslations('DesignSystemComponents.Deals');

  switch (status) {
    case ECourierStatus.DELIVERY_REFUSED:
      return {
        label: t('deliveryRefused.label'),
        title: t('deliveryRefused.title'),
        description: t('deliveryRefused.description'),
      };
    case ECourierStatus.RETURNED:
      return {
        label: t('returned.label'),
        title: t('returned.title'),
        description: t('returned.description'),
      };
    case ECourierStatus.DELIVERED:
      return {
        label: t('delivered.label'),
        title: t('delivered.title'),
        description: t('delivered.description'),
      };
    case ECourierStatus.IN_TRANSIT:
      return {
        label: t('inTransit.label'),
        title: t('inTransit.title'),
        description: t('inTransit.description'),
      };
    case ECourierStatus.CANCELLED:
      return {
        label: t('cancelled.label'),
        title: t('cancelled.title'),
        description: t('cancelled.description'),
      };
    case ECourierStatus.GRADE_REVIEW:
      return {
        label: t('gradeReview.label'),
        title: t('gradeReview.title'),
        description: t('gradeReview.description'),
      };
    default:
      return {
        label: t('notAvailable.label'),
        title: t('notAvailable.title'),
        description: t('notAvailable.description'),
      };
  }
}
